import { Reveal } from "./Reveal";

export const Kicker = ({ children, className = "" }) => (
  <span className={`font-accent text-2xl text-terracotta ${className}`}>{children}</span>
);

// Interior page header band
export const PageHeader = ({ chapter, title, sub, image, compact }) => (
  <section className={`relative ${compact ? "pt-12 pb-12 sm:pt-16 sm:pb-16" : "pt-32 pb-16 sm:pt-40 sm:pb-24"} overflow-hidden`} data-testid="page-header">
    {image && (
      <div className="absolute inset-0 -z-10">
        <img src={image} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-cream via-cream/85 to-cream/40" />
      </div>
    )}
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      {chapter && <Kicker>{chapter}</Kicker>}
      <Reveal>
        <h1 className="mt-2 font-display font-semibold tracking-tight text-4xl sm:text-5xl lg:text-6xl max-w-4xl">
          {title}
        </h1>
      </Reveal>
      {sub && (
        <Reveal delay={0.1}>
          <p className="mt-5 max-w-2xl text-base sm:text-lg text-ink-soft leading-relaxed">{sub}</p>
        </Reveal>
      )}
    </div>
  </section>
);

export const CTAButton = ({ href, to, children, variant = "primary", ...rest }) => {
  const base =
    "inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full text-sm font-semibold transition-all duration-200 hover:scale-105";
  const styles = {
    primary: "bg-terracotta text-white hover:bg-sienna shadow-warm",
    forest: "bg-forest text-white hover:bg-forest/90 shadow-warm",
    outline: "border border-ink/20 text-ink hover:border-terracotta hover:text-terracotta",
  };
  const cls = `${base} ${styles[variant]}`;
  if (href)
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className={cls} {...rest}>
        {children}
      </a>
    );
  return (
    <a href={to} className={cls} {...rest}>
      {children}
    </a>
  );
};
